<template>
  <div>
    <b-modal
      id="modal-unlink-group"
      ref="modal-unlink-group"
      :title="$t('maintenance.unlinkGroup')"
      header-bg-variant="primary"
      header-close-variant="light"
      :ok-title="$t('global.action.save')"
      :cancel-title="$t('global.action.cancel')"
      cancel-variant="outline-primary"
      size="md"
      centered
      modal-class="mc-modal"
    >
      <div class="mb-3">
        <span class="mc-span__label">
          {{ $t('maintenance.modal.unlink.text') }}
        </span>
      </div>
      <div class="mc-accordion-modal">
        <div class="accordion mc-accordion-check" role="tablist">
          <div v-for="(item, index) in serviceGroups" :key="index">
            <div
              header-tag="header"
              role="button"
              type="button"
              v-if="item.ssgroup"
              class="d-flex justify-content-between"
              data-bs-toggle="collapse"
              :data-bs-target="`accordion-${index}`"
              :aria-controls="`accordion-${index}`"
              aria-expanded="false"
            >
              <b-form-checkbox
                @change="(event) => handleSelect(event, item)"
                :checked="selectedIds[item[trackBy]]"
              >
              </b-form-checkbox>
              <strong
                class="d-block mc-help__content-item-faq-list-title"
                v-b-toggle="`accordion-${index}`"
                ><span
                  >{{ item.ssgroup ? item.ssgroup.name : '-' }}
                  <i class="mc-fa icon-outline_arrow-ios-down"></i></span
              ></strong>
            </div>
            <b-collapse
              :id="`accordion-${index}`"
              accordion="my-accordion"
              data-bs-parent="#accordionServices"
            >
              <div class="accordion-body mc-accordion-check__content">
                <div v-for="data in item.ssgroup.service2Ssgroup">
                  <p v-if="data.type == 'DistanceAndTime'">
                    {{
                      `${data.service.name} (${data.service.serviceAction.action}) - ${$t(
                        'maintenance.form.every'
                      )} ${data.intervalDistance} Km & ${data.intervalTime} ${checkValue(
                        data.intervalPeriod
                      )}${$t('maintenance.form.sekali')}`
                    }}
                  </p>
                  <p v-else>
                    {{
                      `${data.service.name} (${data.service.serviceAction.action}) - ${$t(
                        'maintenance.form.every'
                      )} ${minuteToHour(data.intervalHourmeter)}${$t('maintenance.form.sekali')}`
                    }}
                  </p>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="12" class="d-flex justify-content-end">
            <McButton
              variant="secondary"
              @click="cancel()"
              class="me-3"
              :text="$t('global.action.cancel')"
            />
            <McButton
              variant="primary"
              @click="submit"
              icon="icon-outline_link-2"
              :text="$t('maintenance.form.unlink')"
            />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { DETACH_SERVICE_SCHEDULE_GROUP } from '@/services/api/maintenance/serviceSchedules'
import { MixPanel } from '@/mixin/mixpanel'
import { Helper } from '@/mixin/helper'
import McButton from '@/components/McButton'

export default {
  name: 'ModalUnlinkGroup',

  components: {
    McButton,
  },
  mixins: [MixPanel, Helper],

  props: ['serviceSchedules'],

  data() {
    return {
      selectedIds: {},
      trackBy: 'ssgroupId',
      serviceGroups: [],
      selectedService: '',
    }
  },

  created() {
    this.filteredItems(this.serviceSchedules)
  },

  methods: {
    checkValue(data) {
      switch (data) {
        case 'd':
          return this.$t('global.time.day')
        case 'w':
          return this.$t('global.time.week')
        case 'm':
          return this.$t('global.time.month')

        default:
          break
      }
    },

    inputValue(data) {
      switch (data) {
        case 'd':
          return 'day'
        case 'w':
          return 'week'
        case 'm':
          return 'month'

        default:
          break
      }
    },

    filteredItems(data) {
      const uniqueBy =
        (k, s = new Set()) =>
        (o) =>
          !s.has(o[k]) && s.add(o[k])
      let result = data.filter(uniqueBy('ssgroupId')).filter((item) => item['ssgroupId'] != null)

      this.serviceGroups = result
      return result
    },

    handleSelect(checked, data) {
      this.selectedIds = { ...this.selectedIds, [data[this.trackBy]]: checked }
    },

    submit() {
      const selectedIds = Object.keys(this.selectedIds)
      const ids = selectedIds.map((item) => Number(item))

      this.$apollo
        .mutate({
          mutation: DETACH_SERVICE_SCHEDULE_GROUP,
          variables: {
            input: {
              ssgroupIds: ids,
              vehicleId: Number(this.$route.params.vehicleId),
            },
          },
        })

        .then((res) => {
          if (res.data.detachVehicle2Ssgroup.isSuccessful) {
            this.$emit('refreshData')

            this.$mcToast.success({
              component: 'McToastDynamicBody',
              props: {
                contents: [
                  {
                    tag: 'h6',
                    text: this.$t('maintenance.alert.successUnlink'),
                  },
                  {
                    tag: 'p',
                    text:
                      this.$t('maintenance.alert.groupText') +
                      this.$t('maintenance.alert.successUnlinkText'),
                  },
                ],
              },
            })
          } else {
            this.$mcToast.error(res.data.detachVehicle2Ssgroup.message)
          }
        })
      this.$bvModal.hide('modal-unlink-group')
    },
  },
}
</script>
